// src/components/LiveStream.js
import React, { useRef, useState, useEffect } from 'react';
import { ZegoExpressEngine } from 'zego-express-engine-webrtc';
import { GetStreamToken } from '../services/cms.service';

const appID = 861136410;
const server = `wss://webliveroom861136410-api.coolzcloud.com/ws`;
const userID = '690c7648823c236cb04b0ed6';
const userName = `User_${userID}`;
const roomID = 'test-room';

function LiveStream() {
  const localVideoRef = useRef(null);
  const [engine, setEngine] = useState(null);
  const [localStream, setLocalStream] = useState(null);
  const [isStreaming, setIsStreaming] = useState(false);
  const [hasCamera, setHasCamera] = useState(true);

  useEffect(() => {
    const checkDevices = async () => {
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
          setHasCamera(false);
          return;
        }
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(device => device.kind === 'videoinput');
        setHasCamera(videoDevices.length > 0);
      } catch (err) {
        console.error('Error checking devices:', err);
      }
    };

    checkDevices();
    navigator.mediaDevices?.addEventListener('devicechange', checkDevices);
    return () => navigator.mediaDevices?.removeEventListener('devicechange', checkDevices);
  }, []);

  const startStream = async () => {


    try {
      // ✅ Step 1: Ask for permissions
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      } catch (err) {
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          alert('Camera/Microphone access denied. Please allow permissions in your browser settings.');
        } else {
          alert(`Error accessing camera: ${err.message}`);
        }
        return;
      }
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = stream;
      }

      // ✅ Step 2: Create Zego engine
      const zg = new ZegoExpressEngine(appID, server);
      setEngine(zg);

      // ✅ Step 3: Get token (from backend ideally)

      const res = await GetStreamToken(userID, roomID);

      console.log("Token API response live:", res);

      const token = res.token;
      console.log(token, "tokennnnnnnnnnn");

      // ✅ Step 4: Login
      await zg.loginRoom(roomID, token, { userID, userName });


      // ✅ Step 5: Publish stream
      const local = await zg.createStream({ camera: { video: true, audio: true } });
      zg.startPublishingStream(`stream_${userID}`, local);
      setLocalStream(local);

      // ✅ Attach stream to your <video>
      if (localVideoRef.current) {
        localVideoRef.current.srcObject = local;
      }

      setIsStreaming(true);
      console.log('✅ Stream started successfully');
    } catch (error) {
      console.error('❌ Error starting stream:', error);
    }
  };

  const stopStream = async () => {
    try {
      if (engine && localStream) {
        // ✅ Stop publishing
        engine.stopPublishingStream(`stream_${userID}`);

        // ✅ Stop the local stream tracks
        localStream.getTracks().forEach(track => track.stop());
        engine.destroyStream(localStream);

        // ✅ Logout from room and destroy engine
        await engine.logoutRoom(roomID);
        engine.destroyEngine();

        setLocalStream(null);
        setEngine(null);
        setIsStreaming(false);

        if (localVideoRef.current) {
          localVideoRef.current.srcObject = null;
        }

        console.log('🛑 Stream stopped successfully');
      }
    } catch (error) {
      console.error('❌ Error stopping stream:', error);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          padding: '30px 40px',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          width: '80%',
          maxWidth: '900px',
        }}
      >
        <h2 style={{ color: '#333', marginBottom: '20px' }}>Live Stream</h2>

        <div
          style={{
            borderRadius: '12px',
            overflow: 'hidden',
            border: '1px solid #ddd',
            marginBottom: '20px',
          }}
        >
          <video
            ref={localVideoRef}
            autoPlay
            playsInline
            muted
            width="100%"
            style={{
              borderRadius: '12px',
              backgroundColor: '#000',
              maxHeight: '500px',
            }}
          />
        </div>

        {!hasCamera && !isStreaming && (
          <div style={{
            backgroundColor: '#fff5f5',
            border: '1px solid #feb2b2',
            color: '#c53030',
            padding: '10px 15px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
          }}>
            <span>⚠️</span> Camera not detected. Please connect a camera to start.
          </div>
        )}

        {!isStreaming ? (
          <button
            onClick={startStream}
            disabled={!hasCamera}
            style={{
              backgroundColor: hasCamera ? '#007bff' : '#6c757d',
              color: '#fff',
              padding: '12px 30px',
              fontSize: '16px',
              border: 'none',
              borderRadius: '8px',
              cursor: hasCamera ? 'pointer' : 'not-allowed',
              transition: 'background-color 0.3s',
              opacity: hasCamera ? 1 : 0.6
            }}
            onMouseOver={(e) => { if (hasCamera) e.target.style.backgroundColor = '#0056b3'; }}
            onMouseOut={(e) => { if (hasCamera) e.target.style.backgroundColor = '#007bff'; }}
          >
            🎥 Start Live Stream
          </button>
        ) : (
          <button
            onClick={stopStream}
            style={{
              backgroundColor: '#dc3545',
              color: '#fff',
              padding: '12px 30px',
              fontSize: '16px',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = '#a71d2a')}
            onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')}
          >
            ⛔ Stop Live Stream
          </button>
        )}
      </div>
    </div>

  );
}

export default LiveStream;
